import { useState, useMemo } from 'react';
import { Button, useNavigate } from '@ywwwtseng/react-kit';
import { Typography } from '@ywwwtseng/tma-react-kit';
import { SelectGiftType } from '@/components/common/SelectGiftType';
import { GIFT_TYPES } from '@/constants';
import { CreateNormalGiftForm } from '@/components/create-gift/CreateNormalGiftForm';
import { CreateExclusiveGiftForm } from '@/components/create-gift/CreateExclusiveGiftForm';
import { CreateTaskGiftForm } from '@/components/create-gift/CreateTaskGiftForm';
import { CreateChatGrowthGiftForm } from '@/components/create-gift/CreateChatGrowthGiftForm';

export default function CreateGiftScreen() {
  const navigate = useNavigate();
  const [value, setValue] = useState(GIFT_TYPES.NORMAL);
  const form = useMemo(() => {
    switch (value) {
      case GIFT_TYPES.NORMAL:
        return <CreateNormalGiftForm />;
      case GIFT_TYPES.EXCLUSIVE:
        return <CreateExclusiveGiftForm />;
      case GIFT_TYPES.TASK:
        return <CreateTaskGiftForm />;
      case GIFT_TYPES.CHAT_GROWTH:
        return <CreateChatGrowthGiftForm />;
      default:
        return null;
    }
  }, [value]);

  return (
    <div className="flex flex-col justify-start w-full h-full py-3 px-5">
      <div className="flex items-center justify-between">
        <SelectGiftType value={value} onChange={setValue} />
        <Button
          size='xs'
          onClick={() => {
            navigate('Gifts');
          }}
        >
          <Typography size="2" i18n="screens.gift_history" />
        </Button>
      </div>
      {form}
    </div>
  );
}
